export default __webpack_public_path__ + "static/innovator-1-b6e4623155d10ed3cad6301ccf831929.webp";